import React, { useState } from "react";
import { Container, Row, Col, Breadcrumb, Button, Form } from "react-bootstrap";
import { FiHome, FiCalendar, FiPlus, FiChevronUp } from "react-icons/fi";
import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import AttendanceOverviewStatics from "../../../components/Dashboard/attendance-dashboard/AttendanceOverviewStatics";
import AttendanceTrends from "../../../components/Dashboard/attendance-dashboard/AttendanceTrends";
import AttendanceStatus from "../../../components/Dashboard/attendance-dashboard/AttendanceStatus";
import AttendanceSummaryCard from "../../../components/Dashboard/attendance-dashboard/AttendanceSummaryCard";
import OfficeRemoteCard from "../../../components/Dashboard/attendance-dashboard/OfficeRemoteCard";
import FrequentLateArrivals from "../../../components/Dashboard/attendance-dashboard/FrequentLateArrivals";
import MissingPunchesCard from "../../../components/Dashboard/attendance-dashboard/MissingPunchesCard";
import ViolationsStatistics from "../../../components/Dashboard/attendance-dashboard/ViolationsStatistics";
import LateArrivalsCard from "../../../components/Dashboard/attendance-dashboard/LateArrivalsCard";
import AlwaysHereToHelp from "../../../components/Dashboard/attendance-dashboard/AlwaysHereToHelp";
export default function AttendanceDashboardPage() {
  const [date, setDate] = useState(new Date());
  return (
    <div className="attendance-header px-3 px-md-4 py-3">
      <Row className="align-items-center justify-content-between g-3">
        {/* LEFT SIDE */}
        <Col xl={4} lg={4}  sm={12}>
          <div className="my-auto mb-2">
            <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>
              Attendance Dashboard
            </h4>

            <Breadcrumb
              style={{
                background: "transparent",
                padding: 0,
                margin: 0,
                fontSize: "14px",
              }}
            >
              <Breadcrumb.Item>
                <RiHome6Line
                  className="m text-dark"
                  style={{
                    fontSize: "1.2rem", // increased icon size
                    verticalAlign: "middle",
                  }}
                />
              </Breadcrumb.Item>

              <MdKeyboardArrowRight className="mt-1 fs-5" />

              <Breadcrumb.Item
                linkAs="span"
                className="text-dark text-decoration-none fs-6"
              >
                Dashboard
              </Breadcrumb.Item>

              <MdKeyboardArrowRight className="mt-1 fs-5" />

              <Breadcrumb.Item active>
                <span className="text-dark fs-6">Attendance Dashboard</span>
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </Col>

        {/* RIGHT SIDE */}
        <Col xl={8} lg={8} md={12} className="d-flex align-items-center justify-content-end gap-2">
          <div className="d-flex flex-wrap align-items-center justify-content-md-end gap-2">
            {/* TOTAL LEAVES */}
            <div className="leave-box d-flex align-items-center gap-3 p-2 rounded">
              <h5 className="mb-0 d-flex align-items-center gap-1">
                <span className="dot"></span>
                06
                <span className="sub-text">Total Leaves</span>
              </h5>

              <div className="avatar-group ms-3">
                {[
                  "avatar-02-1.jpg",
                  "avatar-03.jpg",
                  "avatar-05.jpg",
                  "avatar-06-1.jpg",
                  "avatar-07-1.jpg",
                ].map((img, i) => (
                  <img
                    key={i}
                    src={`/assets/img/profiles/${img}`}
                    alt="avatar"
                    className="avatar-img"
                  />
                ))}
              </div>
            </div>

            <div style={{ position: "relative", display: "inline-block" }}>
              {/* Icon */}
              <FiCalendar
                style={{
                  position: "absolute",
                  left: "9px",
                  top: "50%",
                  width: "16px",
                  transform: "translateY(-50%)",
                  color: "#6b7280",
                  fontSize: "16px",
                  zIndex: 2,
                }}
              />

              {/* Date Picker */}
              <DatePicker
                selected={date}
                onChange={(d) => setDate(d)}
                dateFormat="MMM yyyy"
                showMonthYearPicker
                className="input-calendar ps-4"
                popperClassName="custom-popper"
                calendarClassName="custom-calendar"
                style={{
                  height: "40px",
                  borderRadius: "8px",
                  border: "1px solid #d1d5db",

                }}
              />

              {/* INLINE STYLE */}
              <style>
                {`
        /* INPUT FOCUS BLUE BORDER */
        .form-control:focus {
          border: 2px solid #3b82f6 !important;
          box-shadow: none !important;
        }

        /* POPUP BOX */
        .custom-calendar {
          border-radius: 12px;
          border: none;
          box-shadow: 0 10px 25px rgba(0,0,0,0.1);
          padding: 15px;
          font-family: Inter, sans-serif;
        }

        /* TRIANGLE POINTER */
        .custom-popper[data-placement^="bottom"] .react-datepicker__triangle {
          fill: white;
          color: white;
          stroke: #e5e7eb;
        }

        /* HEADER */
        .react-datepicker__header {
          background: white;
          border-bottom: none;
          text-align: center;
          padding-bottom: 10px;
        }

        /* YEAR TEXT */
        .react-datepicker__current-month {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 10px;
        }

        /* NAV ICONS */
        .react-datepicker__navigation-icon::before {
          border-color: #374151;
          border-width: 2px 2px 0 0;
        }

        /* MONTH GRID */
        .react-datepicker__month-container {
          width: 260px;
        }

        /* EACH MONTH */
        .react-datepicker__month-text {
          width: 70px;
          padding: 10px 0;
          margin: 6px;
          border-radius: 10px;
          text-align: center;
          color: #6b7280;
          font-size: 15px;
          transition: 0.2s;
        }

        /* HOVER */
        .react-datepicker__month-text:hover {
          background: #f3f4f6;
          color: #111827;
        }

        /* SELECTED MONTH (BLUE PILL) */
        .react-datepicker__month-text--selected {
          background: #f76a19 !important;
          color: white !important;
          font-weight: 500;
          border-radius: 10px;
        }

        `}
              </style>
            </div>

            {/* APPLY BUTTON */}
            <Button className="apply-btn d-flex align-items-center gap-1">
              <FiPlus /> Apply Leave
            </Button>

            {/* COLLAPSE ICON */}
            {/* <div className="collapse-icon">
              <FiChevronUp />
            </div> */}
          </div>
        </Col>

        <AttendanceOverviewStatics className="mt-3" />
        <Row className="mt-3">
  <Col xl={8}>
    <AttendanceTrends />
  </Col>

  <Col xl={4}>
    <AttendanceStatus />
  </Col>
</Row>

        <Row className="mt-3">
  <Col xl={6}>
    <OfficeRemoteCard/>
  </Col>

  <Col xl={6}>
     <AttendanceSummaryCard/>
  </Col>
</Row>
   <Row className="g-3 dashboard-section">

      <Col xl={4}>
        <FrequentLateArrivals/>
      </Col>

      <Col xl={4}>
        <MissingPunchesCard/>
       
      </Col>

      <Col xl={4}>
        <ViolationsStatistics/>
        
      </Col>

     
    </Row>
        <div className="row mt-3">

      <div className="col-lg-7">
        <LateArrivalsCard />
      </div>

      <div className="col-lg-5 mt-3 mt-lg-0">
        <AlwaysHereToHelp />
      </div>

    </div>
      </Row>

      <style>{`
          
          .attendance-header {
  background: #f8f9fb;
}

.react-datepicker__month-text {
  width: 80px;
}
/* Title */
.title {
  font-size: 22px;
  font-weight: 600;
  color: #1f2937;
}
.input-calendar{

  width: 130px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  padding-left: 30px;
  font-size: 13px;
  }
/* Breadcrumb */
.custom-breadcrumb {
  font-size: 13px;
  color: #6b7280;
}

/* Leave Box */
.leave-box {
  border: 1px solid #e5e7eb;
  background: #ffffff;
}

.leave-box h5 {
  font-size: 14px;
  font-weight: 600;
}

.sub-text {
  font-size: 13px;
  font-weight: 400;
  color: #6b7280;
  margin-left: 5px;
}

/* Dot */
.dot {
  width: 6px;
  height: 6px;
  background: #ff6a00;
  border-radius: 50%;
}

/* Avatar Group */
.avatar-group {
  display: flex;
}

.avatar-img {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid #fff;
  margin-left: -8px;
}

/* Date Picker */
.date-box {
  width: 130px;
}

.calendar-icon {
  position: absolute;
  top: 10px;
  left: 10px;
  color: #6b7280;
}

.date-input {
  padding-left: 30px;
  font-size: 13px;
}

/* Button */
.apply-btn {
  background: linear-gradient(90deg, #ff7a18, #ff4d00);
  border: none;
  font-size: 13px;
  padding: 8px 14px;
}

.apply-btn:hover {
  opacity: 0.9;
}

/* Collapse */
.collapse-icon {
  width: 36px;
  height: 36px;
  border: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  cursor: pointer;
}

/* MOBILE */
@media (max-width: 768px) {
  .leave-box {
    width: 100%;
    justify-content: space-between;
  }

  .date-box {
    width: 100%;
  }

  .apply-btn {
    width: 100%;
    justify-content: center;
  }
    
}`}</style>
    </div>
  );
}
